import { useEffect, useRef, MutableRefObject } from "react";

export function useMountedRef(): MutableRefObject<boolean> {
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  return mounted;
}
